class GameConfig {
  public loadedPath: string | undefined;
  public config: ConfigParams = {} as ConfigParams;

  private static instance: GameConfig;

  private constructor() {}

  public static getInstance(): GameConfig {
    if (!GameConfig.instance) {
      GameConfig.instance = new GameConfig();
    }

    return GameConfig.instance;
  }

  async load(path: string): Promise<ConfigParams> {
    console.log(`Loading config from path: ${path}`);

    await fetch(path)
      .then((response) => {
        if (!response.ok) {
          throw new Error(response.statusText);
        }
        return response.json();
      })
      .then((data) => {
        this.config = data;
        this.loadedPath = path;
      });

    console.log("Config loaded data: ", this.config);

    return this.config;
  }

  public loadConfig(data: any): ConfigParams {
    this.config = data;

    return this.config;
  }
}

export enum ColumnAlignment {
  LEFT = "left",
  RIGHT = "right",
}

export type CurrentJackpotDefinition = {
  id: string;
  x: number;
  y: number;
  size: number;
  color: string;
  spin_duration: number;
  delay_show: number;
  max_height: number;
  max_width: number;
};

export type InfoMessagesDefinition = {
  x: number;
  y: number;
  width: number;
  height: number;
  size: number;
  color: string;
  type: "scroll" | "cycle";
  cycle_interval: number;
  scroll_delimeter?: string;
  scroll_margin: number;
  scroll_speed: number;
  messages: string[];
};

export type ConfigParams = {
  app: {
    server_address: string;
    websocket_address: string;
    sign_id: string;
    debug: boolean;
    screenWidth: number;
    screenHeight: number;
    initialVolume: number;
    autoplay: boolean;
    muted: boolean;
  };
  info_messages: InfoMessagesDefinition;
  jackpot_hit: {
    image_path: string;
    video_path: string;
    x: number;
    y: number;
    size: number;
    color: string;
    spin_duration: number;
    delay_show: number;
  };
  current_jackpot: {
    image_path: string;
    video_path: string;
    jackpots: CurrentJackpotDefinition[];
  };
  history: {
    image_path: string;
    video_path: string;
    show_delay_seconds: number;
    hide_before_end_seconds: number;
    numrows: number;
    header: {
      font_size: number;
      y: number;
      color: string;
    };
    rows: {
      start_y: number;
      spacing_y: number;
      date: {
        x: number;
        y: number;
        size: number;
        color: string;
        align: "left" | "right";
      };
      location: {
        x: number;
        y: number;
        size: number;
        color: string;
        align: "left" | "right";
      };
      win: {
        x: number;
        y: number;
        size: number;
        color: string;
        align: "left" | "right";
      };
    };
  };
  i18n: {
    locale: string;
    localesPath: string;
  };
};

export default GameConfig;
